



















import Vue from 'vue';
import { round } from 'lodash';
import { BTooltip } from 'bootstrap-vue';

import generateMapperLink from '../mixins/generateMapperLink';

export default Vue.extend({
  name: 'CoveragePresenter',
  components: {
    BTooltip,
  },
  mixins: [generateMapperLink],
  props: {
    program: {
      type: Object,
      required: true,
    },
    filterFinalized: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    coverage() {
      let objectivesCount = this.program.coveredObjectiveCount;
      if (this.filterFinalized) {
        objectivesCount = this.program.coveredObjectiveFinalCount;
      }
      if (this.program.scopedCounts.objectives === 0) {
        return -1;
      } else {
        return objectivesCount / this.program.scopedCounts.objectives;
      }
    },
    uncoveredObjectiveCount() {
      if (this.filterFinalized) {
        return this.program.scopedCounts.objectives - this.program.coveredObjectiveFinalCount;
      }
      return this.program.scopedCounts.objectives - this.program.coveredObjectiveCount;
    },
    text() {
      if (this.coverage === -1) {
        return 'N/A';
      } else {
        return round(this.coverage * 100, 2) + '%';
      }
    },
    showAlert() {
      return this.coverage >= 0 && this.coverage < 1;
    },
    tooltipText() {
      const verb = this.uncoveredObjectiveCount === 1 ? 'has' : 'have';
      return `${this.uncoveredObjectiveCount} out of ${this.program.scopedCounts.objectives} objectives ${verb} no controls mapped.`;
    },
    tooltipTextFinal() {
      const verb = this.uncoveredObjectiveFinalCount === 1 ? 'has' : 'have';
      return `${this.uncoveredObjectiveFinalCount} out of ${this.program.scopedCounts.objectives} objectives ${verb} no finalized controls mapped.`;
    },
  },
});
